var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.211,
    height: 105.479,
    viewBox: "0 0 131.211 105.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "google cloud",
    transform: "translate(.011 -.009)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M343.716,29.129l11.405-11.406.758-4.8c-20.781-18.9-53.818-16.755-72.557,4.471A52.674,52.674,0,0,0,272.2,38.233l4.083-.578L299.094,33.9l1.758-1.8a28.573,28.573,0,0,1,39.017-3.164Z",
    "data-name": "Path 215",
    transform: "translate(-256.467)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M1133.583,248.174a51.382,51.382,0,0,0-15.489-24.974l-16.009,16.009a28.452,28.452,0,0,1,10.445,22.568v2.84a14.167,14.167,0,1,1,0,28.334H1084l-2.8,3.042v17.091l2.8,2.684h28.531a36.956,36.956,0,0,0,21.053-67.594",
    "data-name": "Path 216",
    transform: "translate(-1018.677 -210.282)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M272.471,1431.289h28.5v-22.811h-28.5a14.04,14.04,0,0,1-5.842-1.278l-4.043,1.238L251.1,1419.843l-1,3.881a36.987,36.987,0,0,0,22.371,7.565",
    "data-name": "Path 217",
    transform: "translate(-235.646 -1325.803)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M36.826,544.3a37.062,37.062,0,0,0-22.371,66.438l16.53-16.53a14.247,14.247,0,1,1,18.849-18.849l16.53-16.53A37.023,37.023,0,0,0,36.826,544.3",
    "data-name": "Path 218",
    transform: "translate(0 -512.807)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloud);
export default __webpack_public_path__ + "static/media/google-cloud.ea61890bf6f113898d0ea1edee8ae72e.svg";
export { ForwardRef as ReactComponent };